// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3mv_N","type":"styles_type__2YYUy","choices":"styles_choices__P-LUu"};